module.exports = __webpack_public_path__ + "static/media/logo.1c1fd625.png";